import * as React from 'react';
import { Grid } from '@mui/material';
import SaleshubInfo from './SaleshubInfo';
import BermudaInfo from './BermudaInfo';
import DefaultInfo from './DefaultInfo';
import useAppids from 'hooks/useAppids';
import RpsInfo from './RpsInfo';
import SprntInfo from './SprntInfo';
import DTCInfo from './DTCInfo';

const InfoPanel = ({ type }) => {
  const allAppIds = useAppids();

  const getInfoPanel = () => {
    const {
      isSalesHubAppid,
      isBermudaAppid,
      isRpsAppid,
      isSprntAppid,
      isDTCPIAppid,
    } = allAppIds;
    if (isSalesHubAppid) return <SaleshubInfo type={type} />;
    if (isBermudaAppid) return <BermudaInfo type={type} />;
    if (isRpsAppid) return <RpsInfo type={type} />;
    if (isSprntAppid) return <SprntInfo type={type} />;
    if (isDTCPIAppid) return <DTCInfo type={type} />;

    return <DefaultInfo />;
  };

  return (
    <Grid sx={styles.container}>
      <Grid sx={styles.grayBox}>{getInfoPanel()}</Grid>
    </Grid>
  );
};

const styles = {
  container: {
    flexBasis: '50%',
    maxWidth: '590px',
  },
  grayBox: {
    background: '#FAFAFA',
    padding: '32px',
  },
};

export default InfoPanel;
